export const isFacebookUrl = (url: string) => /^https:\/\/(www\.|m\.)?facebook\.com\/.+/i.test(url);
